import React from "react";
import { Row, Col } from "antd";
import { InputItem } from "../../../components/forms/FormItems";
import { FormattedMessage } from "react-intl";
import Surface from "../../../components/layouts/Surface";
import FormHeader from "../../../components/forms/FormHeader";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import FreeTextAndSelectItem from "../../../components/forms/FreeTextAndSelectItem";

const Satisfaction = (props) => {
  const { enabled } = props;
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.house_visits.satisfaction" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <FreeTextAndSelectItem
                  name="report.satisfaction_feedback"
                  category="house_visits"
                  params={{
                    name: "meta/system_tables/house_visits/satisfaction_feedback",
                  }}
                  disabled={!enabled}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <FreeTextAndSelectItem
                  name="report.plan_hours_feedback"
                  category="house_visits"
                  params={{
                    name: "meta/system_tables/house_visits/plan_hours_feedback",
                  }}
                  disabled={!enabled}
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <FreeTextAndSelectItem
                  name="report.complains_feedback"
                  category="house_visits"
                  params={{
                    name: "meta/system_tables/house_visits/complains_feedback",
                  }}
                  disabled={!enabled}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem
                  name="report.requests_feedback"
                  category="house_visits"
                  disabled={!enabled}
                />
              </div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
    </div>
  );
};

export default Satisfaction;
